module.exports = __webpack_public_path__ + "img/arrow.3ce90b43.svg";